export const CHANGE_DMARC_PASS_TYPE = 'CHANGE_DMARC_PASS_TYPE';
